import createLucideIcon from '../createLucideIcon';

const PieChart = createLucideIcon('PieChart', [
  ['path', { d: 'M21.21 15.89A10 10 0 1 1 8 2.83', key: 'k2fpak' }],
  ['path', { d: 'M22 12A10 10 0 0 0 12 2v10z', key: '1rfc4y' }],
]);

export default PieChart;
